import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  NbDialogService,
  NbMediaBreakpointsService,
  NbMenuItem,
  NbMenuService,
  NbThemeService,
} from "@nebular/theme";

import { find, remove, clone } from "lodash";

import { Router } from "@angular/router";
import { EmployeeService } from "../../../services/employee.service";

import { Employee } from "../../../models/employee.model";
import { History } from "../../../models/history.model";
import { DialogYesNoPromptComponent } from "../../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { DialogEmployeeComponent } from "../../dialog-employee/dialog-employee.component";
import { DialogHistoryComponent } from "../../dialog-history/dialog-history.component";
import { UserService } from "../../../@core/services/user.service";
import { filter, map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: "ngx-view-employee",
  styleUrls: ["./view-employee.component.scss"],
  templateUrl: "./view-employee.component.html",
})
export class ViewEmployeeComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() mode?: string = ""; //home / employee
  @Input() employee: Employee;
  @Input() isMore? = false;
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  view = "main";
  uid = "";
  isMobile = false;
  menuItems: NbMenuItem[] = [
    { title: "Chi tiết", icon: "external-link-outline" },
  ];

  constructor(
    public userService: UserService,
    private employeeService: EmployeeService,
    private dialogService: NbDialogService,
    private router: Router,
    private breakpointService: NbMediaBreakpointsService,
    private themeService: NbThemeService,
    private nbMenuService: NbMenuService
  ) {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }
        } else {
          this.uid = "anonymous";
        }
      });

    const { sm } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < sm),
        takeUntil(this.destroy$)
      )
      .subscribe((isLessThanSm: boolean) => {
        this.isMobile = isLessThanSm;
      });
  }

  ngOnInit() {
    this.nbMenuService
      .onItemClick()
      .pipe(
        filter(({ tag }) => tag === `action-buttons-${this.employee.id}`),
        map(({ item }) => item),
        takeUntil(this.destroy$)
      )
      .subscribe((item) => {
        switch (item.title) {
          case "Sửa":
            this.edit(item.data);
            break;
          case "Xóa":
            this.delete(item.data.id);
            break;
          case "Chi tiết":
            break;
          default:
            break;
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadContent(value) {
    this.isMore = value;
  }

  loadButtonAction(item) {
    this.menuItems = [
      { title: "Sửa", icon: "edit-2-outline", data: item },
      { title: "Xóa", icon: "trash-2-outline", data: { id: item.id } },
      {
        title: "Chi tiết",
        icon: "external-link-outline",
        link: `/employee/${this.employee.id}`,
      },
    ];
  }

  navigateRef(item) {
    if (item.navigateUrl != "") {
      this.router.navigateByUrl(item.navigateUrl);
    }
  }

  delete(item) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.employeeService
            .delete(this.shopId, item.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              this.onDelete.emit(item.id);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  edit(item: Employee) {
    let lecBk = new Employee();
    lecBk = clone(item);
    this.dialogService
      .open(DialogEmployeeComponent, {
        context: {
          header: "Cập nhật bài viết",
          mode: "edit",
          shopId: this.shopId,
          employee: lecBk,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          item = value;
          this.employee = value;
          this.onEdit.emit(value);
        }
      });
  }

  createHistory(item: Employee) {
    //
  }

  createReceipt(item: Employee) {
    // let lecNew = new History();
    // lecNew.employeeId = item.id;
    // lecNew.fullName = item.fullName;
    // lecNew.dobYear = item.dobYear;
    // lecNew.issueDate = new Date();
    // this.dialogService
    //   .open(DialogHistoryComponent, {
    //     context: {
    //       header: "Tạo trạng thái",
    //       mode: "new",
    //       history: lecNew,
    //     },
    //     closeOnBackdropClick: false,
    //   })
    //   .onClose.subscribe((value) => {
    //     if (value) {
    //     }
    //   });
  }

  viewHistory(item) {
    this.router.navigateByUrl("/employee/" + item.id);
  }
}
